import { actionTypes } from '../actions/settings';
import { actionTypes as accessControlActionTypes } from '../actions/access-control';

let settings = JSON.parse(localStorage.getItem('settings'));

const initialState = {
  settings: null,
  accessControl: {
    dashboard: true,
    cardapio: true,
    minhaLoja: true,
    clientes: true,
    cupons: true,
    pedidos: true
  }
};

const SettingsReducer = (state = settings || initialState, action) => {
  let newState = state;
  switch (action.type) {
    case actionTypes.SET_STORE_OPEN_HOURS: {
      newState = { ...state, settings: action.payload };
      break;
    }
    case actionTypes.SET_STORE_EXCEPTIONS_HOURS: {
      newState = { ...state, settings: action.payload };
      break;
    }
    case accessControlActionTypes.SET_ACCESS_CONTROL: {
      newState = { ...state, accessControl: action.payload };
      break;
    }
    default: {
      newState = state;
      break;
    }
  }
  if (newState) {
    localStorage.setItem('settings', JSON.stringify(newState));
  } else {
    localStorage.removeItem('settings');
  }
  return newState;
};

export default SettingsReducer;
